import React from 'react'
import classnames from 'classnames/bind'

import SmallArrow from 'components/icons/SmallArrow'
import Button from 'components/shared/Button'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const LoadMore = ({
  onClick,
  url,
  page,
  loading,
  tagName,
  className,
  children,
  withPagination,
  theme = 'gray',
}) => {
  return (
    <div className={cx(css.buttonContainer, className)}>
      <Button
        className={cx(css.button, { loading })}
        theme={theme}
        onClick={(e) => {
          e.preventDefault()

          if (withPagination) {
            window.history.replaceState(null, '', url)
          }
          onClick && onClick(e)
        }}
        tagName={tagName}
      >
        {children || 'See more'}
        <SmallArrow theme="current-color" className={css.smallArrow} />
      </Button>
    </div>
  )
}

export default LoadMore
